import {
  setAnalysisChartCategory,
  setAnalysisChartExpenses,
  setAnalysisChartPaymentMethod,
  setAnalysisChartService,
  setAnalysisChartSupplier,
  setExpensesSearchQuery
} from "../../lib/pageSearchState.js";

const expenseTileActions = {
  "spent-total-this-month": { visibilityFilter: "this-month", searchQuery: "" },
  "spent-total-last-month": { visibilityFilter: "last-month", searchQuery: "" },
  "spent-total-this-year": { visibilityFilter: "all", searchQuery: "" },
  "spent-ongoing-this-month": { visibilityFilter: "this-month", searchQuery: "ongoing" },
  "spent-ongoing-last-month": { visibilityFilter: "last-month", searchQuery: "ongoing" },
  "spent-ongoing-this-year": { visibilityFilter: "all", searchQuery: "ongoing" },
  "spent-irregular-this-month": { visibilityFilter: "this-month", searchQuery: "irregular" },
  "spent-irregular-last-month": { visibilityFilter: "last-month", searchQuery: "irregular" },
  "spent-irregular-this-year": { visibilityFilter: "all", searchQuery: "irregular" }
};

const argumentExpenseTileActions = {
  "category-spent-this-month": {
    argKey: "category",
    visibilityFilter: "this-month"
  },
  "category-spent-this-year": {
    argKey: "category",
    visibilityFilter: "all"
  },
  "supplier-spent-this-month": {
    argKey: "supplier",
    visibilityFilter: "this-month"
  },
  "supplier-spent-this-year": {
    argKey: "supplier",
    visibilityFilter: "all"
  },
  "service-spent-this-month": {
    argKey: "service",
    visibilityFilter: "this-month"
  },
  "service-spent-this-year": {
    argKey: "service",
    visibilityFilter: "all"
  },
  "payment-method-spent-this-month": {
    argKey: "paymentMethod",
    visibilityFilter: "this-month"
  },
  "payment-method-spent-this-year": {
    argKey: "paymentMethod",
    visibilityFilter: "all"
  }
};

const chartTileActions = {
  "chart-expenses": { type: "chart", metric: "expenses" },
  "chart-category-expenses": { type: "chart", metric: "category", argKey: "category" },
  "chart-supplier-expenses": { type: "chart", metric: "supplier", argKey: "supplier" },
  "chart-service-expenses": { type: "chart", metric: "service", argKey: "service" },
  "chart-payment-method-expenses": { type: "chart", metric: "paymentMethod", argKey: "paymentMethod" }
};

export function createHomeTileExpenseAction(config) {
  const directAction = expenseTileActions[config?.metricKey];

  if (directAction) {
    return {
      type: "expenses",
      ...directAction
    };
  }

  const argumentAction = argumentExpenseTileActions[config?.metricKey];
  const argumentValue = config?.args?.[argumentAction?.argKey];

  if (argumentAction && argumentValue) {
    return {
      type: "expenses",
      visibilityFilter: argumentAction.visibilityFilter,
      searchQuery: String(argumentValue)
    };
  }

  const chartAction = chartTileActions[config?.metricKey];
  const chartArgumentValue = config?.args?.[chartAction?.argKey];

  if (!chartAction || (chartAction.argKey && !chartArgumentValue)) {
    return null;
  }

  return {
    ...chartAction,
    value: chartArgumentValue ? String(chartArgumentValue) : ""
  };
}

export function runHomeTileExpenseAction(action, {
  navigateToPage,
  onExpensesVisibilityFilterChange
} = {}) {
  if (!action) {
    return;
  }

  if (action.type === "chart") {
    if (action.metric === "category") {
      setAnalysisChartCategory(action.value);
    } else if (action.metric === "supplier") {
      setAnalysisChartSupplier(action.value);
    } else if (action.metric === "service") {
      setAnalysisChartService(action.value);
    } else if (action.metric === "paymentMethod") {
      setAnalysisChartPaymentMethod(action.value);
    } else {
      setAnalysisChartExpenses();
    }

    navigateToPage?.("analysis", "charts", { contextual: true });
    return;
  }

  setExpensesSearchQuery(action.searchQuery);
  onExpensesVisibilityFilterChange?.(action.visibilityFilter);
  navigateToPage?.("expenses", null, { contextual: true });
}
